module.exports = __webpack_public_path__ + "050c9c4a800c023e3f6ad1779add3959.otf";


//////////////////
// WEBPACK FOOTER
// ./dist/14155.otf
// module id = 752
// module chunks = 0